module.exports = __webpack_public_path__ + "static/4-309b84aa02daa2b8ed0e959783e0bc4a.svg";